import { Color } from "three";

export class DataIndexReference{
    constructor(col:number, row:number, orgColor?: Color){
        this.col = col;
        this.row = row;
        this.orgColor = orgColor;
    }
    public col!: number;
    public row!: number;
    public orgColor?: Color;
}